<div (click)="toggleDropdown()" [ngClass]="[dropdownStyle ? 'register-dropdown' : '']" class="select flex-center" [ngClass]="dropdownSize ? 'bigger' : ''" appClickOutside (clickOutside)="onClickOutside($event)">
  <span>{{dropdownLabel}}</span>
  <div *ngIf="dropdown" class="dropdown" >
    <div *ngFor="let s of sourceList" (click)="changeLabel(s)" class="dropdown-item flex">
      {{s.label}}
    </div>
  </div>
</div>
